import type {
  AdminCyclesQuery,
  CycleSkipReason,
  CycleStatus,
} from "~/types/admin-cycles";

export const cycleStatusFilters = [
  "scheduled",
  "locked",
  "skipped",
  "canceled",
  "returned",
] as const satisfies readonly CycleStatus[];

export const cycleSkipReasonFilters = [
  "customer",
  "out_of_stock",
  "payment_failed",
  "disaster",
  "stock_shortage",
] as const satisfies readonly CycleSkipReason[];

const cycleStatusLabels: Record<string, string> = {
  scheduled: "予定",
  locked: "確定",
  skipped: "スキップ",
  canceled: "キャンセル",
  returned: "未受取終了",
};

const cycleSkipReasonLabels: Record<string, string> = {
  customer: "顧客スキップ",
  out_of_stock: "在庫切れ（未使用）",
  payment_failed: "課金失敗",
  disaster: "災害停止",
  stock_shortage: "在庫不足",
};

export function formatCycleStatus(value: string): string {
  return cycleStatusLabels[value] ?? value;
}

export function formatCycleSkipReason(value: string | null): string {
  if (value === null) return "—";
  return cycleSkipReasonLabels[value] ?? value;
}

export type BadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "warning"
  | "outline";

export function cycleStatusBadgeVariant(value: string): BadgeVariant {
  switch (value) {
    case "locked":
      return "default";
    case "skipped":
      return "warning";
    case "canceled":
    case "returned":
      return "destructive";
    case "scheduled":
      return "secondary";
    default:
      return "outline";
  }
}

export function buildAdminCyclesQuery(query: AdminCyclesQuery): string {
  const params = new URLSearchParams();
  params.set("status", query.status ?? "skipped");
  if (query.skipReason !== undefined) {
    params.set("skip_reason", query.skipReason);
  }
  if (query.limit !== undefined) {
    params.set("limit", String(query.limit));
  }
  if (query.offset !== undefined && query.offset !== 0) {
    params.set("offset", String(query.offset));
  }
  return `?${params.toString()}`;
}

export function hasNextPage(rowCount: number, limit: number): boolean {
  return rowCount === limit;
}
